const PopupDlog = {
  methods: {
    valor_cookie(nome_cookie) {
      // Adiciona o sinal de = na frente do nome do cookie
      var cname = ' ' + nome_cookie + '=';

      // Obtém todos os cookies do documento
      var cookies = document.cookie;

      // Verifica se seu cookie existe
      if (cookies.indexOf(cname) == -1) {
        return false;
      }

      // Remove a parte que não interessa dos cookies
      cookies = cookies.substr(cookies.indexOf(cname), cookies.length);

      // Obtém o valor do cookie até o ;
      if (cookies.indexOf(';') != -1) {
        cookies = cookies.substr(0, cookies.indexOf(';'));
      }

      // Remove o nome do cookie e o sinal de =
      cookies = cookies.split('=')[1];

      // Retorna apenas o valor do cookie
      return decodeURI(cookies);
    },
    popupDlog: function () {
      if (this.valor_cookie('showPopupDlog') === 'false') {
        $('.popupDlog').remove();
      }
      $(document).on('click', 'button.popupDlog-btnClose', function () {
        document.cookie = 'showPopupDlog=false';
        $('.popupDlog').addClass('closing');
        $('.button.popupDlog-btnClose').addClass('closing');
        setTimeout(() => {
          $('.popupDlog').remove();
        }, 500)
      })
    },
  },
  init: function () {
    var _this = this;
    _this.methods.popupDlog();

  }
}

const DiscountAllStore = {

  formatMoney: function (e) {
    return e.toFixed(2).replace(".", ",").replace(/(\d)(?=(\d{3})+\,)/g, "$1.")
  },

  addFlagPercent: function () {
    // produtos default
    setTimeout(function () {
      $('.ProductItem').each(function () {

        var _elem = $(this);

        if (_elem.find('.e-price-compare').length) {

          var _oldPrice = _elem.find('.e-price-compare');
          var _oldPriceText = Number(_oldPrice.text().trim().split('R$ ')[1].replace(',', '.'));

          var _bestPrice = _elem.find('.e-price-item');
          var _bestPriceText = Number(_bestPrice.text().trim().split('R$ ')[1].replace(',', '.'));

          var _percentTotal = (_bestPriceText * 100) / _oldPriceText;
          var _porcent = 100 - _percentTotal;
          // _elem.find('.ProductItem__ImageWrapper').prepend('<div class="e-usebob-flag-descont"><span><span></span> ' + _porcent.toFixed(0) + '%</span></div>');
        }
      });
    }, 1000);

    // produto destaque
    setTimeout(function () {
      $('.FeaturedProduct').each(function () {

        var _elem = $(this);

        if (_elem.find('.ProductMeta__PriceList .e-price-compare').length) {

          var _oldPrice = _elem.find('.e-price-compare');
          var _oldPriceText = Number(_oldPrice.text().trim().split('R$ ')[1].replace(',', '.'));

          var _bestPrice = _elem.find('.e-price-item');
          var _bestPriceText = Number(_bestPrice.text().trim().split('R$ ')[1].replace(',', '.'));

          var _percentTotal = (_bestPriceText * 100) / _oldPriceText;
          var _porcent = 100 - _percentTotal;
          _elem.find('.FeaturedProduct__Gallery').prepend('<div class="e-flags-product"><span class="e-flag-discount-off">' + _porcent.toFixed(0) + '% OFF</span></div>');
        }
      });
    }, 1000);

  },

  // se tiver valor cadastrado no campo Desconto em Toda Loja, atribui desconto nos produtos
  addPricePercent: function () {
    var discountPercent = $('.e-discount-all-store').val();

    if (discountPercent > 0) {
      $('.ProductItem').each(function () {
        var priceCalc = 0;
        var priceValue = 0;

        var priceReal = $(this).find('.ProductItem__PriceList .ProductItem__Price.e-price-item').text();
        var priceFormat = $(this).find('.ProductItem__PriceList .ProductItem__Price.e-price-item').text().split("R$ ")[1].replace(".", "").replace(",", ".");

        priceCalc = parseFloat(priceFormat - (priceFormat * discountPercent / 100)); // calculo preço
        priceValue = ((Math.ceil(priceCalc * 100)) / 100); // arredondamento do preço

        // $(this).find('.ProductItem__PriceList .ProductItem__Price').remove();
        // $(this).find('.ProductItem__PriceList').prepend('<div class="ProductItem__PriceList  Heading"><span class="ProductItem__Price Price Price--compareAt Text--subdued" data-money-convertible="">' + priceReal + '</span><span class="ProductItem__Price Price Price--highlight Text--subdued" data-money-convertible=""> R$ ' + DiscountAllStore.formatMoney(priceValue) + '</span></div>');
        // $(this).find('.ProductItem__ImageWrapper').prepend('<div class="e-flags-product"><span class="e-flag-discount-off">' + discountPercent + '% OFF</span></div>');
      });
    }
  },

  init: function () {
    // this.addFlagPercent();
    this.addPricePercent();
  }

}

const couponDiscountMinicart = {


  openShippingMinicart: function () {
    const btnOpenFrete = $('#e-btn-open-shipping');
    // e.preventDefault();

    btnOpenFrete.click(function () {
      $(this).hide();
      const shippingForm = $('.container-calculator');
      shippingForm.css('display', 'inline')
    });
  },

  shippingMinicart: function () {
    const btnShipping = $('#shipping-calculator .calcFrete');
    btnShipping.click(function () {
      const responseShipping = $('#wrapper-response');
      responseShipping.removeClass('active');
      const findFeedback = setInterval(() => {
        const responseShippingSuccess = $('#wrapper-response #shipping-rates-feedback.success');


        if (responseShippingSuccess.length > 0) {
          clearInterval(findFeedback)
          $('.container-calculator').hide();
          $('.shipping-title').addClass('hidden');
          responseShipping.addClass('active');

          const adressElement = $('#address_zip')
          const adressZip = adressElement.val();
          const zipCodeClose = $('#zipCodeClose');
          if (zipCodeClose.length == 0) {
            $('#shipping-rates-feedback').append(`<span><span id="zipCodeClose">${adressZip}</span><span id="zipBtnClose">x</span></span>`)
            couponDiscountMinicart.closeShippingMinicart();
          }

        }
      }, 500)

      setTimeout(() => {
        const responseShippingError = $('#wrapper-response .error');
        if (responseShippingError.length > 0) {
          const zipCodeError = $('#zipCodeError');
          if (zipCodeError.length == 0) {
            $('.Drawer__Footer-finished > div:first-child').prepend(`<p id="zipCodeError">${$(responseShippingError).html()}</p>`)
            setTimeout(() => {
              $('#zipCodeError').html('');
            }, 2500)
          } else {
            $(zipCodeError).html($(responseShippingError).html());
            setTimeout(() => {
              $('#zipCodeError').html('');
            }, 2500)
          }
        }
      }, 700)
    });
  },

  closeShippingMinicart: function () {
    const btnCloseShipping = $('#zipBtnClose');
    const responseShipping = $('#wrapper-response')

    btnCloseShipping.click(function () {
      responseShipping.removeClass('active');
      $('.container-calculator').css('display', 'inline');
      $('.shipping-title').removeClass('hidden')
    })
  },

  hasCoupon: function () {
    let i = 0;
    const myInterval = setInterval(() => {
      i++;
      if (i >= 50) {
        clearInterval(myInterval);
      }
      var codeCoupon = $(".scDiscount__container > #scDiscountApp > div > div form #code").val() || $('#scDiscountApp > div > div > div > div.sc_simple-info__tag > span > span > span').html();

      if (codeCoupon) {
        var valueDiscount =
          $(".sc_simple-info .sc_code-info div:nth-child(2) span:nth-child(2)").text() ||
          $(".sc_simple-info .sc_code-info div:nth-child(2) span").text();

        if (valueDiscount) {
          $(".e-coupon-discount-cart__form-add").hide();
          const cart_totalPrice = +$(
            ".e-usebob-cart-drawer-btn.minicart__checkout_btn.Cart__Checkout s"
          ).attr("data-cart-total");
          if (cart_totalPrice) clearInterval(myInterval);
          const totalDiscount = +valueDiscount
            .replace("$", "")
            .replace(".", "");
          const correctDiscount =
            (Math.ceil((totalDiscount / cart_totalPrice) * 100) / 100) *
            cart_totalPrice;
          const correctValueDiscountString =
            Math.round(correctDiscount).toString();
          const roundedValueDiscount =
            "$" +
            correctValueDiscountString.substring(
              0,
              correctValueDiscountString.length - 2
            ) +
            "." +
            correctValueDiscountString.substring(
              correctValueDiscountString.length - 2,
              correctValueDiscountString.length
            );
          const upperCode = codeCoupon.toUpperCase();
          const valueDiscountNumber =
            +valueDiscount.replace("$", "") + 0.01;
          // add text code coupon visible customer
          $(".e-coupon-discount-cart__apply--code").html(codeCoupon);
          // add value discount for visible customer
          if (valueDiscount == "frete grátis") {
            $(".e-coupon-discount-cart__apply--value").html(valueDiscount);
          } else if (
            upperCode == "BASE" ||
            upperCode == "KONJAC" ||
            upperCode == "NECESSAIRE" ||
            upperCode == "QUEROLIPBALM" ||
            upperCode.includes("FREE") ||
            upperCode.includes("FRIEND")
          ) {
            $(".e-coupon-discount-cart__apply--value").html(valueDiscount);
          } else {
            $(".e-coupon-discount-cart__apply--value").html(
              "- " + roundedValueDiscount
            );
          }

          //hide form
          $(".scDiscount__container > #scDiscountApp > div").hide();
          $(".e-coupon-discount-cart").show();

          // show code and value discount
          $(".e-coupon-discount-cart__apply").addClass("e-active");

          document.cookie = `promocode=${codeCoupon}; path=/;`;
          document.cookie =
            "bubbstore_checkout=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          document.cookie =
            "XSRF-TOKEN=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          usebobBrinde.handleBarStatus();
          upsellMinicart.handleValueGift(Math.round(correctDiscount));
          // upsellMinicart.verificarCart();
          // usebobBrindeBolsinha.canAddFreeProduct(Math.round(correctDiscount));
        }
      }
    }, 150);
  },


  openformCoupon: function () {
    //hide btn open form
    $('.e-coupon-discount-cart__form-add').hide();

    //show form
    $('.scDiscount__container > #scDiscountApp > div').show();
    $('.scDiscount__container > #scDiscountApp > div > div form #submit').attr('value', 'ok')
    $('.e-coupon-discount-cart').hide();

  },

  addCouponForm: function () {
    var btnAddCoupon = $('.scDiscount__container > #scDiscountApp > div > div form #submit');

    btnAddCoupon.click(function (e) {
      // setTimeout(()=>{
      couponDiscountMinicart.hasCoupon();
      // }, 500)  
    });
  },

  removeCouponForm: function () {
    var btnRemoveCoupon = $('.e-coupon-discount-cart__apply--remove');

    btnRemoveCoupon.click(function (e) {
      e.preventDefault();

      // remove DCart coupon
      document.querySelector('.sc_simple-info > .sc_simple-info__tag button').click();

      //show form
      $('.scDiscount__container > #scDiscountApp > div').show();

      // hide code and value discount
      $('.e-coupon-discount-cart__apply').removeClass('e-active');
      $('.e-coupon-discount-cart').hide();



      document.cookie = `promocode=; path=/;`;

      var load_event = new Event("changeCupom");
      window.dispatchEvent(load_event);

    });
  },

  addProductHandleCoupon: function (sku) {
    const btnRemoveCoupon = document.querySelector('.e-coupon-discount-cart__apply--remove');
    const hasCoupon = document.querySelector('.sc_simple-container.sc_simple-container--complete');
    const input = document.querySelector('input#code[name="code"]');
    const submitButton = document.querySelector('input#submit');
    let couponDiscount;

    if (sku.includes('KJ')) couponDiscount = 'KONJAC';
    else if (sku.includes('NC')) couponDiscount = 'NECESSAIRE';
    else if (sku.includes('BZ')) couponDiscount = 'BASE';
    else return;

    const event = new Event('click');
    const inputEvent = new Event('input');

    if (hasCoupon) {
      btnRemoveCoupon.dispatchEvent(event);
      setTimeout(() => {
        // couponDiscountMinicart.openformCoupon()
        input.value = couponDiscount;
        input.dispatchEvent(inputEvent);
        setTimeout(() => {
          submitButton.dispatchEvent(event);
        }, 1500)
      }, 2000)
    } else {
      // couponDiscountMinicart.openformCoupon()
      input.value = couponDiscount;
      input.dispatchEvent(inputEvent);

      setTimeout(() => {
        submitButton.dispatchEvent(event);
      }, 1500)

      document.cookie = "bubbstore_checkout=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      document.cookie = "XSRF-TOKEN=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      document.cookie = `promocode=${couponDiscount}; path=/;`;

    }
  },

  init: function () {
    this.shippingMinicart();
    this.addCouponForm();
    this.removeCouponForm();
    this.hasCoupon();
    this.openShippingMinicart();
    // this.openformCoupon();
  }
}

const Account = {
  methods: {
    emailExist: function (email) {
      return new Promise(function (resolve, reject) {
        $.ajax({
          url: `https://agenciaeconverse.com.br/cliente/use-bob/userExist/?email=${email}`,
          type: 'GET',
          success: function (res) {
            const {
              error,
              userExist
            } = res;
            if (error === false && userExist) {
              resolve(true)
            } else {
              resolve(false);
            }
          }
        })
      })
    },
    isIncorrectEmail: function () {
      const _this = this;

      if ($('.Form__Alert.Alert.Alert--error').length && $('.Form__Alert.Alert.Alert--error').text() === 'E-mail ou senha incorretos.') {
        //VERIFY IF THIS E-MAIL EXIST ON DATA BASE
        Account.methods.verifyIfHaveEmailResgistred();

      } else {
        setTimeout(function () {
          _this.isIncorrectEmail();
        }, 100);
      }
    },
    verifyIfHaveEmailResgistred: function () {
      const _this = this;
      if (localStorage.userEmail !== undefined && localStorage.userEmail !== '') {
        const email = localStorage.userEmail;
        _this.emailExist(email).then(res => {
          if (res) {
            $('#customer_login .Form__Alert.Alert.Alert--error').addClass('notify');
            /* $('#customer_login .Form__Alert.Alert.Alert--error').html(`Crie uma conta para poder acessar seu histórico de pedidos <a href="https://www.usebob.com.br/account/register">AQUI</a>.
            Mesmo que já tenha realizado algum pedido, é necessário criar uma conta.
            <button class="close-notify"><span>+</span></button>
            `); */
            $('#customer_login .Form__Alert.Alert.Alert--error').html(`Crie uma conta para acessar o histórico de pedidos. Mesmo que já tenha feito sua compra, é necessário criar uma conta com o mesmo e-mail utilizado na sua Assinatura B.O.B ou em pedidos anteriores.
                        <button class="close-notify"><span>+</span></button>
                        `);
            $(document).on('click', 'button.close-notify', function () {
              $('#customer_login .Form__Alert.Alert.Alert--error').remove();
            });
          } else {
            $('#customer_login .Form__Alert.Alert.Alert--error').addClass('active');
          }
        });
      }

    }
  },
  init: function () {
    $('#customer_login').submit(function () {
      localStorage.userEmail = $('input.Form__Input[name="customer[email]"]').val();
    })
    this.methods.isIncorrectEmail();
  }
}

const WhatsAppShare = {
  methods: {
    addLinkOnShareButton: function () {
      let productLink = window.location.href;
      $('.e-product__share--icons a.e-icon-whatsapp').attr('href', `https://api.whatsapp.com/send?text=Faça parte da revolução zero plástico com a B.O.B ${productLink}`);
    }
  },
  init: function () {
    this.methods.addLinkOnShareButton();
  }
}

const LetterMothersDay = {
  methods: {
    getCaractersWriteLetter: function () {
      var totalCaractersTextarea = 500;

      var qtdaCaractersWritter = $('.Cart__Note.Form__Textarea').val();
      if (qtdaCaractersWritter != undefined) {
        qtdaCaractersWritter = qtdaCaractersWritter.length;
      }

      var calcCaractersRemaining = totalCaractersTextarea - qtdaCaractersWritter;

      calcCaractersRemaining = calcCaractersRemaining.toString(); // converte numero para texto

      if (calcCaractersRemaining.indexOf('-') == 0) {
        //console.log('text NEGATIVO');
        $('.Form__Item-qtda-caracters').addClass('e-error');
        $('.Form__Item-qtda-caracters').html(calcCaractersRemaining + ' (reduza o texto) ');
      } else {
        //console.log('text POSITIVO');
        $('.Form__Item-qtda-caracters').removeClass('e-error');
        $('.Form__Item-qtda-caracters').html(calcCaractersRemaining);
      }

      //$('.Form__Item-qtda-caracters').html(calcCaractersRemaining);
    },
    keyUpCaractersWritter: function () {
      var totalCaractersTextarea = 500;

      $('body').on('keyup', '.Cart__Note.Form__Textarea', function () {
        var qtdaCaracterKeyUp = $(this).val().length;

        var calcRemaining = totalCaractersTextarea - qtdaCaracterKeyUp;
        calcRemaining = calcRemaining.toString(); // converte numero para texto

        if (calcRemaining.indexOf('-') == 0) {
          //console.log('text NEGATIVO');
          $('.Form__Item-qtda-caracters').addClass('e-error');
          $('.Form__Item-qtda-caracters').html(calcRemaining + ' (reduza o texto) ');
        } else {
          //console.log('text POSITIVO');
          $('.Form__Item-qtda-caracters').removeClass('e-error');
          $('.Form__Item-qtda-caracters').html(calcRemaining);
        }
      });
    },
    closePopUpLetterMothersDay: function () {
      $('body').on('click', '.Cart__Note-close-form', function () {
        $('.Cart__OffscreenNoteContainer [data-action="toggle-cart-note"]').trigger('click');
      });
    }
  },
  init: function () {
    this.methods.getCaractersWriteLetter();
    this.methods.keyUpCaractersWritter();
    this.methods.closePopUpLetterMothersDay();
  }
}

const minicartButtonTelegramObs = {
  methods: {
    viewFormTelegram: function () {
      var textareaNote = $('.Cart__Note.Form__Textarea').val();
      if (textareaNote != "") {
        $('.e-btn-note-minicart').removeClass('e-note-minicart-open'); // tira o gif piscando do botao escreva
        $('.e-btn-note-minicart').addClass('e-note-minicart-edit'); // mostra o btn edit
      } else {
        $('.e-btn-note-minicart').addClass('e-note-minicart-open'); // volta o gif piscando do botao escreva
        $('.e-btn-note-minicart').removeClass('e-note-minicart-edit'); // tira o btn edit
      }
    },
    openFormTelegram: function () {
      $('body').on('click', '.e-btn-note-minicart', function () {
        $('.Cart__NoteButton.e-note-open').trigger('click');
      });
    },
    closeFormTelegram: function () {
      $('.e-btn-note-save').click(function () {
        minicartButtonTelegramObs.methods.viewFormTelegram();
      });
    }
  },
  init: function () {
    this.methods.viewFormTelegram();
    this.methods.openFormTelegram();
    this.methods.closeFormTelegram();
  }
}

PopupDlog.init();

$(document).ready(function () {
  WhatsAppShare.init();

  DiscountAllStore.init();

  var currentPathName = window.location.pathname;

  if (currentPathName.match(/account/) !== null) {
    Account.init();
  }

  LetterMothersDay.init();

  minicartButtonTelegramObs.init();
});

var removePriceOfGirtCardd = () => {
  $('.Cart__ItemList .CartItemWrapper').each((index, element) => {
    let productName = $(element).find('.CartItem__Title.Heading a').text().toLowerCase();

    if (productName.includes('gift card b.o.b') && $(element).find('.CartItem__Variant').text().includes('.')) {
      $(element).find('.CartItem__Variant').remove();
    }
  });
}

setInterval(removePriceOfGirtCardd, 100);

function btnRateScroll() {
  $(document).on('click', '.spr-summary-actions a', function () {
    if ($('.spr-form').is(':visible')) {
      $('html, body').animate({
        scrollTop: $('.spr-form').offset().top - 100
      }, 1000);
    }
  })
}

btnRateScroll();


// Adicionar tag de Desconto no carrinho quando tem promoção.

function addTagDescontProductInCart() {
  // console.log("active tag");

  const infoProducts = Array.from(document.querySelectorAll(".CartItemWrapper .CartItem__Info .CartItem__PriceList"));
  const fieldsDesconts = Array.from(document.querySelectorAll(".CartItemWrapper .CartItem__Info .CartItem__PriceList #e-usebob-descont-product"));

  for (let i = 0; i < infoProducts.length; i++) {

    const currentComparePrice = infoProducts[i].querySelector("[data-compare-price]").dataset.comparePrice;
    const currentOriginalPrice = infoProducts[i].querySelector("[data-original-price]").dataset.originalPrice;

    if (currentComparePrice) {

      const descont = 100 - (currentOriginalPrice * 100) / currentComparePrice;
      fieldsDesconts[i].textContent = `(${descont}% OFF)`;
    }
  }
}

function leadMore() {

  const paragraph = document.querySelector(".e-wrapper-description .e-product__infos--description-short");
  const content = document.querySelector(".e-wrapper-description");
  const btnLeadMore = document.querySelector(".e-description-button a");

  if (paragraph && content && btnLeadMore) {

    const contentHeight = 48;
    // console.log(contentHeight);

    btnLeadMore.addEventListener("click", handleAccordion);

    let openIsDescription = false;

    function handleAccordion() {
      content.classList.toggle("open");

      if (!openIsDescription) {
        const paragraphHeight = paragraph.offsetHeight;
        content.style.height = `${paragraphHeight}px`;
      }
      else {
        content.style.height = `${contentHeight}px`;
      }

      openIsDescription = !openIsDescription;
      resetBtn();
    }

    function resetBtn() {

      if (openIsDescription) {
        btnLeadMore.textContent = "see less"
      }
      else {
        btnLeadMore.textContent = "view more"
      }

    }
  }

}

leadMore();

function handlePassword() {

  if (
    !(document.querySelectorAll(".Form__Container__Input span.icon-login-password") &&
      document.querySelectorAll(".Form__Container__Input input"))
  ) {
    return;
  }

  const buttonsHandlePassword = Array.from(document.querySelectorAll(".Form__Container__Input span.icon-login-password"));
  const fieldsPassword = Array.from(document.querySelectorAll(".Form__Container__Input input"));

  for (let i = 0; i < buttonsHandlePassword.length; i++) {

    buttonsHandlePassword[i]
      .addEventListener("click", function () {
        if (fieldsPassword[i].type == "password") {
          fieldsPassword[i].setAttribute("type", "text");
          buttonsHandlePassword[i].setAttribute("title", "esconder minha senha");
          buttonsHandlePassword[i].classList.add("visible-password");
        }
        else {
          fieldsPassword[i].setAttribute("type", "password");
          buttonsHandlePassword[i].setAttribute("title", "ver minha senha");
          buttonsHandlePassword[i].classList.remove("visible-password");
        }
      })
  }
}

handlePassword();